/**
 * PAC-1374 — the one-shot hand-off from the company sign-up to the WMS module:
 * "this organisation has just been created; its first screen is its first site".
 *
 * sessionStorage, because the shell and the WMS MFE share one window but no
 * code. The key is duplicated on purpose in
 * `modules/wms/src/utils/firstSite.ts` (modules cannot import from the shell);
 * keep the two in lock-step. Storage can be unavailable (private window,
 * blocked site data) — the hand-off is a convenience, so every access is
 * guarded and a failure just means WMS shows its "add your first site" banner
 * without opening the dialog.
 */
export const FIRST_SITE_PENDING_KEY = "metaship.wms.firstSitePendingOrgId";

export function markFirstSitePending(organisationId: number): void {
  try {
    window.sessionStorage.setItem(FIRST_SITE_PENDING_KEY, String(organisationId));
  } catch {
    /* storage unavailable — WMS still shows the banner */
  }
}
